import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/logo.jpg';
import _imports_1 from '@/img/planidemo.jpg';
import _imports_2 from '@/img/arrowroundLeft.png';
import _imports_3 from '@/img/arrowroundRight.png';
const _withScopeId = n => (_pushScopeId("data-v-13054190"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "orderForm" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header text-center" }, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 })
], -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_4 = { class: "titleGreen" };
const _hoisted_5 = {
    class: "mt-4",
    ref: "titolo"
};
const _hoisted_6 = { class: "form-group" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-green" }, "*", -1));
const _hoisted_8 = {
    key: 0,
    class: "text-center balla title"
};
const _hoisted_9 = { class: "text-center mt-2" };
const _hoisted_10 = {
    class: "band mt-3",
    ref: "planiTitle"
};
const _hoisted_11 = {
    key: 0,
    class: "balla title"
};
const _hoisted_12 = { class: "row mt-2" };
const _hoisted_13 = { class: "grayBox" };
const _hoisted_14 = { class: "row align-items-center" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "planiDemo",
        src: _imports_1
    })
], -1));
const _hoisted_16 = { class: "col-md-6" };
const _hoisted_17 = { class: "title" };
const _hoisted_18 = {
    key: 0,
    class: "text-center balla title"
};
const _hoisted_19 = { class: "mt-3" };
const _hoisted_20 = { class: "col-sm-12" };
const _hoisted_21 = { class: "dropPlani mt-3" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", { src: _imports_2 }, null, -1));
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_24 = { class: "text-center mt-2" };
const _hoisted_25 = { class: "tileContainer" };
const _hoisted_26 = ["src"];
const _hoisted_27 = { class: "tilename" };
const _hoisted_28 = {
    key: 0,
    class: "col-md-4 mb-2"
};
const _hoisted_29 = {
    class: "greenBorderBox dimensioni",
    ref: "dimensioni"
};
const _hoisted_30 = { class: "title text-green mb-4" };
const _hoisted_31 = { class: "my-2" };
const _hoisted_32 = {
    key: 0,
    class: "balla title"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = { class: "metri" };
const _hoisted_35 = { class: "ms-2" };
const _hoisted_36 = { class: "crediti" };
const _hoisted_37 = /*#__PURE__*/ _createTextVNode(" )");
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_39 = { class: "band green" };
const _hoisted_40 = { class: "lowerBand mb-3" };
const _hoisted_41 = { class: "row" };
const _hoisted_42 = {
    key: 0,
    class: "col-md-4 detailBox mb-2"
};
const _hoisted_43 = { class: "band mb-2" };
const _hoisted_44 = { class: "greenBorderBox grayBox" };
const _hoisted_45 = { class: "mt-2" };
const _hoisted_46 = {
    key: 1,
    class: "col-md-4 detailBox mb-2"
};
const _hoisted_47 = { class: "band mb-2" };
const _hoisted_48 = { class: "greenBorderBox grayBox" };
const _hoisted_49 = { class: "mt-2" };
const _hoisted_50 = { class: "mt-2" };
const _hoisted_51 = { class: "col-md-4 detailBox mb-2" };
const _hoisted_52 = { class: "band mb-2" };
const _hoisted_53 = { class: "greenBorderBox grayBox" };
const _hoisted_54 = { class: "mt-2" };
const _hoisted_55 = { class: "col-md-4 detailBox mb-2" };
const _hoisted_56 = { class: "band mb-2" };
const _hoisted_57 = { class: "greenBorderBox grayBox" };
const _hoisted_58 = { class: "mt-2" };
const _hoisted_59 = { class: "mt-2" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_61 = { class: "band greenBg" };
const _hoisted_62 = { class: "preferenze" };
const _hoisted_63 = { class: "d-flex justify-content-around align-items-center" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "me-2",
    src: _imports_3
}, null, -1));
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "ms-2",
    src: _imports_2
}, null, -1));
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tratteggio mt-4" }, null, -1));
const _hoisted_67 = { class: "text-red title text-center" };
const _hoisted_68 = { class: "band bandaPrezzo mt-4" };
const _hoisted_69 = {
    key: 0,
    class: "rigaPrezzo"
};
const _hoisted_70 = { class: "text-end pe-4" };
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tratteggio white" }, null, -1));
const _hoisted_72 = { class: "text-start ps-4" };
const _hoisted_73 = {
    key: 1,
    class: "rigaPrezzo"
};
const _hoisted_74 = { class: "text-end pe-4" };
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tratteggio white" }, null, -1));
const _hoisted_76 = { class: "text-start ps-4" };
const _hoisted_77 = { key: 0 };
const _hoisted_78 = { class: "mb-2" };
const _hoisted_79 = { class: "progress mb-4" };
const _hoisted_80 = { class: "text-center mt-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_localized_text = _resolveComponent("localized-text");
    const _component_file_dropper_list = _resolveComponent("file-dropper-list");
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.prodotto.displayName[_ctx.$store.state.selectedLanguage]), 1),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                        localizedKey: "Titolo della lavorazione",
                        text: "Titolo della lavorazione"
                    }),
                    _hoisted_7
                ]),
                (_ctx.titoloError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_localized_text, {
                            class: "text-red",
                            localizedKey: "Il titolo è obbligatorio!",
                            text: "Il titolo è obbligatorio!"
                        })
                    ]))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.vm.titolo) = $event))
                }, null, 512), [
                    [_vModelText, _ctx.vm.titolo]
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_localized_text, {
                        localizedKey: "Puoi usare l'indirizzo dell'immobile, ti servirà per ricercare le tue planimetrie in archivio",
                        text: "Puoi usare l'indirizzo dell'immobile, ti servirà per ricercare le tue planimetrie in archivio"
                    })
                ])
            ])
        ], 512),
        _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_localized_text, {
                localizedKey: "CARICA LA PLANIMETRIA CATASTALE",
                text: "CARICA LA PLANIMETRIA CATASTALE"
            }),
            (_ctx.planimetriaAllegatiError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_localized_text, {
                        class: "text-red",
                        localizedKey: "Ricordati di caricare la planimetria!",
                        text: "Ricordati di caricare la planimetria!"
                    })
                ]))
                : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
                class: _normalizeClass([_ctx.multipliers > 0 ? 'col-md-8' : 'col-md-12', "mb-2"])
            }, [
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_localized_text, {
                                    localizedKey: "IMPORTANTE",
                                    text: "IMPORTANTE"
                                }),
                                (_ctx.planimetriaScalimetroError)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createVNode(_component_localized_text, {
                                            class: "text-red",
                                            localizedKey: "Campo obbligatorio",
                                            text: "Campo obbligatorio"
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                                _createVNode(_component_localized_text, {
                                    localizedKey: "scalimetro_description",
                                    text: "È presente lo scalimetro o sono indicate almeno due misure dell'immobile? Se così non fosse non potremo lavorare la planimetria, accertati che ci siano le misure per scalare correttamente il disegno!"
                                })
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", {
                                    class: "d-flex align-items-center pointer",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.vm.scalimetro = 'SI'))
                                }, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["btn btn-option flex-shrink-0 me-2", { selected: _ctx.vm.scalimetro == 'SI' }])
                                    }, null, 2),
                                    _createElementVNode("span", null, [
                                        _createVNode(_component_localized_text, {
                                            localizedKey: "SI",
                                            text: "SI"
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", {
                                    class: "d-flex align-items-center pointer",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.vm.scalimetro = 'NO'))
                                }, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["btn btn-option flex-shrink-0 me-2", { selected: _ctx.vm.scalimetro == 'NO' }])
                                    }, null, 2),
                                    _createElementVNode("span", null, [
                                        _createVNode(_component_localized_text, {
                                            localizedKey: "scalimetro_no",
                                            text: "No, procedete lo stesso, sono consapevole che la planimetria potrà non essere lavorata."
                                        })
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_file_dropper_list, {
                                    modelValue: _ctx.planiAttachments,
                                    "onUpdate:modelValue": [
                                        _cache[3] || (_cache[3] = ($event) => ((_ctx.planiAttachments) = $event)),
                                        _ctx.resetPlaniErrors
                                    ]
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_localized_text, {
                                            localizedKey: "Scegli file o trascina direttamente qui",
                                            text: "Scegli file o trascina direttamente qui"
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "onUpdate:modelValue"]),
                                _hoisted_22
                            ]),
                            (_ctx.loadingEstateFiles)
                                ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                                : (_ctx.estateFiles.length > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_23,
                                        _createElementVNode("div", _hoisted_24, [
                                            _createVNode(_component_localized_text, {
                                                localizedKey: "Immagini caricate dall'immobile",
                                                text: "Immagini caricate dall'immobile"
                                            })
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateFiles, (item, i) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: "tile",
                                                    key: i
                                                }, [
                                                    _createElementVNode("img", {
                                                        src: 'data:image/png;base64,' + item.b64Content
                                                    }, null, 8, _hoisted_26),
                                                    _createElementVNode("div", _hoisted_27, _toDisplayString(item.filename), 1)
                                                ]));
                                            }), 128))
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ], 2),
            (_ctx.multipliers > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_localized_text, {
                                    localizedKey: "QUALI SONO LE DIMENSIONI COMMERCIALI DELL'IMMOBILE?",
                                    text: "QUALI SONO LE DIMENSIONI COMMERCIALI DELL'IMMOBILE?"
                                })
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_localized_text, {
                                    localizedKey: "spiegazione_dimensioni_commerciali_form",
                                    text: "Il costo del servizio varia in base alla dimensione commerciale dell'immobile"
                                })
                            ]),
                            (_ctx.dimensioniError)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createVNode(_component_localized_text, {
                                        class: "text-red",
                                        localizedKey: "Campo obbligatorio",
                                        text: "Campo obbligatorio"
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multipliers, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: item,
                                    class: "pointer greenBorderBoxItem",
                                    onClick: ($event) => (_ctx.vm.moltiplicatoreMetratura = item)
                                }, [
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["btn btn-option", { selected: _ctx.vm.moltiplicatoreMetratura == item }])
                                        }, null, 2),
                                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.multiplierBase * (item - 1)) + " - " + _toDisplayString(_ctx.multiplierBase * item) + " mq", 1)
                                    ]),
                                    _createElementVNode("span", _hoisted_36, [
                                        _createTextVNode("( " + _toDisplayString(item) + " ", 1),
                                        _createVNode(_component_localized_text, {
                                            localizedKey: "CREDITI RICHIESTI",
                                            text: "CREDITI RICHIESTI"
                                        }),
                                        _hoisted_37
                                    ])
                                ], 8, _hoisted_33));
                            }), 128))
                        ])
                    ], 512)
                ]))
                : _createCommentVNode("", true)
        ]),
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_localized_text, {
                localizedKey: "AIUTACI A REALIZZARE LA PLANIMETRIA NEL PIÙ BREVE TEMPO POSSIBILE!",
                text: "AIUTACI A REALIZZARE LA PLANIMETRIA NEL PIÙ BREVE TEMPO POSSIBILE!"
            })
        ]),
        _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_localized_text, {
                localizedKey: "COMPILANDO CORRETTAMENTE TUTTI I CAMPI EVITEREMO DI CONTATTARTI PER AVERE INFORMAZIONI AGGIUNTIVE",
                text: "COMPILANDO CORRETTAMENTE TUTTI I CAMPI EVITEREMO DI CONTATTARTI PER AVERE INFORMAZIONI AGGIUNTIVE"
            })
        ]),
        _createElementVNode("div", _hoisted_41, [
            (_ctx.isRenderInterni)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_localized_text, {
                            localizedKey: "arredi_google_label",
                            text: "Cerca gli arredi che preferisci su Google!"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_localized_text, {
                            localizedKey: "arredi_google_description",
                            text: "Se hai già delle idee particolari, puoi cercare su Google Immagini il singolo arredo che preferisci e cercheremo di accontentarti. Se per noi non è possibile inserire quello specifico arredo, ne aggiungeremo uno il più simile possibile. Questa sezione non è obbligatoria ma è altamente consigliata per evitare modifiche successive."
                        })
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_file_dropper_list, {
                            modelValue: _ctx.muriAttachments,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.muriAttachments) = $event))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_localized_text, {
                                    localizedKey: "Scegli file o trascina direttamente qui",
                                    text: "Scegli file o trascina direttamente qui"
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue"])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_localized_text, {
                            localizedKey: "muri_interni_label",
                            text: "VUOI MODIFICARE I MURI INTERNI?"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_localized_text, {
                            localizedKey: "muri_interni_description",
                            text: "Se vuoi modficare i muri interni ( per esempio vuoi\r\n                    togliere una parete oppure vuoi aggiungere un\r\n                    bagno ) carica qui la planimetria disegna a mano\r\n                    con le modifiche ( puoi usare delle X sui muri da\r\n                    togliere o disegnare a mano nuovi muri da inserire ).\r\n                    IMPORTANTE: Senza questa planimetria non\r\n                    potremo realizzare alcun tipo di modifica allo\r\n                    stato di fatto."
                        })
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_file_dropper_list, {
                            modelValue: _ctx.muriAttachments,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.muriAttachments) = $event))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_localized_text, {
                                    localizedKey: "Scegli file o trascina direttamente qui",
                                    text: "Scegli file o trascina direttamente qui"
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_localized_text, {
                            localizedKey: "Planimetria facoltativa",
                            text: "Planimetria facoltativa"
                        })
                    ])
                ])),
            _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_localized_text, {
                        localizedKey: "foto_immobile_label",
                        text: "HAI DELLE FOTO DELL'IMMOBILE?"
                    })
                ]),
                _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_localized_text, {
                        localizedKey: "Se vuoi che seguiamo lo stato di fatto",
                        text: "Se vuoi che seguiamo lo stato di fatto carica le foto\r\n                    in questa sezione. Rappresenteremo sia i pavimenti\r\n                    che gli arredi così come rappresentato dalle foto."
                    })
                ]),
                _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_file_dropper_list, {
                        modelValue: _ctx.fotoAttachments,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.fotoAttachments) = $event))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_localized_text, {
                                localizedKey: "Scegli file o trascina direttamente qui",
                                text: "Scegli file o trascina direttamente qui"
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ])
            ]),
            _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_localized_text, {
                        localizedKey: "PLANIMETRIA CON LE DESTINAZIONI D'USO?",
                        text: "PLANIMETRIA CON LE DESTINAZIONI D'USO?"
                    })
                ]),
                _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_localized_text, {
                        localizedKey: "Destinazioni duso_text",
                        text: "Se hai una planimetria che indica le destinazioni d'uso, caricala qui"
                    })
                ]),
                _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_file_dropper_list, {
                        modelValue: _ctx.destinazioniAttachments,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.destinazioniAttachments) = $event))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_localized_text, {
                                localizedKey: "Scegli file o trascina direttamente qui",
                                text: "Scegli file o trascina direttamente qui"
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_localized_text, {
                            localizedKey: "Planimetria facoltativa",
                            text: "Planimetria facoltativa"
                        })
                    ])
                ])
            ])
        ]),
        _hoisted_60,
        _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_localized_text, {
                localizedKey: "QUALSIASI ALTRA PREFERENZA POTRAI SCRIVERLA QUI",
                text: "QUALSIASI ALTRA PREFERENZA POTRAI SCRIVERLA QUI"
            })
        ]),
        _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.vm.note) = $event)),
                    rows: "4"
                }, null, 512), [
                    [_vModelText, _ctx.vm.note],
                    [_directive_localizedPlaceholder, { key: 'Es. Vorrei dei pavimenti chiari e un arredamento moderno...', value: 'Es. Vorrei dei pavimenti chiari e un arredamento moderno...' }]
                ]),
                _hoisted_65
            ]),
            _hoisted_66
        ]),
        _createElementVNode("div", _hoisted_67, [
            (_ctx.isRenderInterni)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 0,
                    localizedKey: "render_bozza_description",
                    text: "Riceverete i render in versione BOZZA entro 4/5 giorni lavorativi in modo tale da effettuare le modifiche necessarie prima di procedere al render in alta definizione."
                }))
                : (_openBlock(), _createBlock(_component_localized_text, {
                    key: 1,
                    localizedKey: "preferenze_note_description",
                    text: "Ricordati di scriverci in questo modulo qualsiasi tipo di preferenza o richiesta particolare. Se sai già in anticipo che ci sono delle inesattezze sulla planimetria catastale, comunicacelo!"
                }))
        ]),
        _createElementVNode("div", _hoisted_68, [
            (_ctx.creditsAmount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_localized_text, {
                            localizedKey: "CREDITI",
                            text: "CREDITI"
                        })
                    ]),
                    _hoisted_71,
                    _createElementVNode("div", _hoisted_72, [
                        _createTextVNode(_toDisplayString(_ctx.creditsAmount) + " ", 1),
                        _createVNode(_component_localized_text, {
                            localizedKey: "crediti",
                            text: "crediti"
                        })
                    ])
                ]))
                : _createCommentVNode("", true),
            (_ctx.euroAmount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_localized_text, {
                            localizedKey: "EURO",
                            text: "EURO"
                        })
                    ]),
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$filters.currency(_ctx.euroAmount)) + " €", 1)
                ]))
                : _createCommentVNode("", true)
        ]),
        (_ctx.sending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                    _createVNode(_component_localized_text, {
                        class: "titleGreen",
                        localizedKey: "Ordine in corso",
                        text: "Ordine in corso"
                    })
                ]),
                _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", {
                        class: "progress-bar progress-bar-animated",
                        style: _normalizeStyle('width: ' + _ctx.progressPerc + '%;')
                    }, null, 4)
                ]),
                _createVNode(_component_mini_spinner)
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_80, [
            (!_ctx.sending)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-send",
                    onClick: _cache[9] || (_cache[9] =
                        //@ts-ignore
                        (...args) => (_ctx.send && _ctx.send(...args)))
                }, [
                    _createVNode(_component_localized_text, {
                        localizedKey: "INVIA ORA LA RICHIESTA",
                        text: "INVIA ORA LA RICHIESTA"
                    })
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
